export default "<p>informes-periciales works!</p>\n"